<template>
  <el-row :gutter="10">
    <el-col :span="4" class="white">
      <div class="tree-box">
        <el-tree
          :data="department"
          class="tree-class"
          :default-expand-all="true"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :expand-on-click-node="false"
        ></el-tree>
      </div>
    </el-col>
    <el-col :span="20" class="white">
      <base-table
        :columns="columns"
        :data="kindList"
        :pager="pager"
        :pageShow="pageShow"
        @handleAction="handleAction"
        @handleCurrentChange="handleCurrentChange"
        @handleSwitchChange="handleSwitchChange"
      >
        <template v-slot:action>
          <el-button type="primary" @click="handleCreate"><i class="el-icon-plus"></i> <span>新增部门</span></el-button>
        </template>
      </base-table>
    </el-col>
  </el-row>
  <BaseDialog
    :configDialogInfo="configDialogInfo"
    @closeDialog="closeDialog"
    @determineDialog="determineDialog">
  </BaseDialog>
</template>

<script>
import { getCurrentInstance, reactive, ref } from 'vue';
import utils from '@/utils/utils';
import { ElMessage } from 'element-plus';
import moment from 'moment';
export default {
  name: "boatOrganizationalStructure",
  setup() {
    const { proxy } = getCurrentInstance();
    const _id = ref('')
    let queryValue = {};

    // 初始化表单对象
    const boatKind = ref({
      _id: '',
      beginWharfId: '',
      boatId: '',
      payWay: '',
      boatCardId: '',
      status: '',
      saleTime: '',
    });

    // 查询事件， 获取码头列表
    const handleQuery = values => {
      const condition = utils.checkParmas(values);
      if(condition.saleTime)condition.saleTime = moment(condition.saleTime).format('YYYY-MM-DD');
      pager.pageNum = 1;
      queryValue = condition;
      permissionsDepartmentList(condition);
    };

    // 初始化分页对象
    const pager = reactive({
      pageNum: 1,
      pageSize: 10
    });

    // 是否展示分页
    const pageShow = ref(true);

    // 定义动态表格-格式
    const columns = reactive([
      {
        label: '部门名称',
        prop: 'name'
      },
      {
        label: '成员数量',
        prop: 'totalCount',
      },
      {
        label: '负责人员',
        prop: 'director',
        formatter (row, column, value) {
          return value.length;
        },
      },
      {
        label: '部门描述',
        prop: "note",
      },
      {
        label: '启用状态',
        prop: "enable",
        type: 'isswitch'
      },
      {
        label: '更新时间',
        prop: "updateTime",
      },
      {
        type: 'action',
        label: '操作',
        width: 150,
        list: [
          {
            type: 'primary',
            text: '编辑',
            visible: true
          },
          {
            type: 'danger',
            text: '删除',
            visible: true
          },
        ]
      }
    ]);

    // 初始化列表对象
    const kindList = ref([]);

    // 获取数据列表
    const permissionsDepartmentList = async values => {
      const params = utils.pageService(pager, values);
      const { data, totalNum } = await proxy.$api.permissionsDepartmentList(params);
      kindList.value = data;
      pager.total = totalNum;
    };

    // 点击权限树
    const handleNodeClick = data => {
      queryValue.pid = data.value;
      pager.pageNum = 1;
      permissionsDepartmentList(queryValue);
    };

    // 分页事件处理
    const handleCurrentChange = current => {
      pager.pageNum = current;
      permissionsDepartmentList(queryValue);
    };

    // 操作
    const handleAction = async values => {
      const { index } = values;
      _id.value = values.row._id;
      if(index === 0){
        configDialogInfo.formInfo.formList.forEach(item => {
          item.value && (item.value = [])
          item.text && (item.text = '')
        });
        configDialogInfo.formInfo.formList[1].text = values.row.name;
        configDialogInfo.formInfo.formList[3].text = values.row.note;

        configDialogInfo.formInfo.formList[2].value = values.row.director.map(v => v.key);
        configDialogInfo.dialogTitle = '修改部门';
        configDialogInfo.dialogVisible = true;
      }else if(index === 1){
        proxy.$confirm('确认删除？', '提示').then(async () => {
          const params = {
            _id: _id.value
          };
          await proxy.$api.permissionsDepartmentDel(params);
          proxy.$message({
            type: 'success',
            message: '已删除!'
          });
          permissionsDepartmentList();
        }).catch((_) => {})
      }
    };

    // 权限树
    const department = ref([]);

    // 新增部门
    const handleCreate = () => {
      if(configDialogInfo.dialogTitle !== '新增权限'){
        configDialogInfo.formInfo.formList.forEach(item => {
          item.value && (item.value = [])
          item.text && (item.text = '')
        });
      };
      configDialogInfo.dialogTitle = '新增权限'
      configDialogInfo.dialogVisible = true;
    };

    // 写入部门
    const configDialogInfo = reactive({
      dialogTitle: '',
      successText: '保 存',
      failText: '取 消',
      dialogVisible: false,
      dialogWidth: '30%',
      formInfo: {
        labelWidth: '80px',
        labelPosition: 'right',
        formList: [
          {
            type: 'cascader',
            placeholder: '请选择上级部门',
            model: 'department',
            label: '上级部门',
            options: [],
            rules: [{ required: true, message: '请选择上级部门', trigger: 'blur' }]
          },
          {
            type: 'input',
            text: '',
            placeholder: '请输入部门名称',
            label: '部门名称',
            rules: [{ required: true, message: '请输入部门名称', trigger: 'blur' }]
          },
          {
            type: 'select',
            text: '',
            placeholder: '请选择负责人员',
            label: '负责人员',
            value: [],
            options: [],
            multiple: true,
            rules: [{ required: true, message: '请选择负责人员', trigger: 'blur' }]
          },
          {
            type: 'textarea',
            text: '',
            placeholder: '请输入描述信息',
            label: '描述信息',
            rules: [{ required: true, message: '请输入描述信息', trigger: 'blur' }]
          },
        ]
      }
    });
    permissionsDepartmentList();

    // 部门树
    const permissionsDepartmentTree = async () => {
      const data = await proxy.$api.permissionsDepartmentTree();
      configDialogInfo.formInfo.formList[0].options = data;
      department.value = data;
    };
    permissionsDepartmentTree();

    // 负责人员
    const permissionsUserDic = async () => {
      const data = await proxy.$api.permissionsUserDic();
      data.shift();
      configDialogInfo.formInfo.formList[0];
      utils.writeDict(data, configDialogInfo.formInfo.formList[2]);
    };
    permissionsUserDic();

    // 关闭弹窗
    const closeDialog = () => {
      configDialogInfo.dialogVisible = false;
    };

    // 弹窗确定
    const determineDialog = async () => {
      const { formList } = configDialogInfo.formInfo;
      if(!formList[0].value)return ElMessage.error('请选择上级部门');
      if(!formList[1].text)return ElMessage.error('请输入部门名称');
      if(!formList[2].value.length)return ElMessage.error('请选择负责人员');
      if(!formList[3].text)return ElMessage.error('请输入描述信息');
      const params = {
        parent: formList[0].value[formList[0].value.length - 1],
        name: formList[1].text,
        director: formList[2].value,
        note: formList[3].text,
      };
      if(configDialogInfo.dialogTitle === '新增权限'){
        const data = await proxy.$api.permissionsDepartmentAdd(params);
        if(data){
          ElMessage.success('新增完成');
          configDialogInfo.dialogVisible = false;
        }
      }else{
        params._id = _id.value;
        const data = await proxy.$api.permissionsDepartmentUpdate(params);
        if(data){
          ElMessage.success('修改完成');
          configDialogInfo.dialogVisible = false;
        }
      }
      permissionsDepartmentList();
      permissionsDepartmentTree();
    };

    // 改变启动状态
    const handleSwitchChange = async row => {
      const params = {
        _id: row._id,
        enable: row.enable
      };
      await proxy.$api.permissionsDepartmentEnable(params);
    };

    return {
      permissionsDepartmentList,
      columns,
      pager,
      pageShow,
      kindList,
      handleCurrentChange,
      handleAction,
      boatKind,
      handleQuery,
      department,
      handleNodeClick,
      handleCreate,
      configDialogInfo,
      closeDialog,
      determineDialog,
      permissionsDepartmentTree,
      _id,
      handleSwitchChange,
      permissionsUserDic,
      permissionsDepartmentTree,
    };
  },
};
</script>

<style scoped lang='less'>
:deep(.tree-class){
  .el-tree-node__content{
    .el-tree-node__label{
      font-size: 14px;
    };
  }
};
.tree-box{
  border: 1px solid rgba(242, 242, 242, 1);
  padding: 20px 0;
  height: 100%;
}
</style>
